export enum InsuranceTypeEnum {
  MACHINE = 'machine',
  RESPONSIBILITY = 'responsibility',
  STOPPED_BUSINESS = 'stopped_business',
  BUILDING = 'building',
}
